import { useLocation } from 'react-router-dom';
import Card from '../components/Card';

type Outcome = 'accepted' | 'rejected' | 'changes_requested';

interface LocationState {
  outcome?: Outcome;
}

const COPY: Record<Outcome, { title: string; body: string; tone: string }> = {
  accepted: {
    title: 'Quote accepted',
    body: 'Thanks for accepting! The trades team has been notified and will be in touch about the next steps.',
    tone: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  },
  rejected: {
    title: 'Quote declined',
    body: 'Thanks for letting us know. The trades team has been notified.',
    tone: 'border-slate-200 bg-slate-50 text-slate-900',
  },
  changes_requested: {
    title: 'Change request sent',
    body: 'Your feedback has been sent to the trades team. They will review and follow up shortly.',
    tone: 'border-amber-200 bg-amber-50 text-amber-900',
  },
};

const Confirmation = () => {
  const location = useLocation();
  const state = (location.state ?? {}) as LocationState;
  const outcome: Outcome = state.outcome ?? 'accepted';
  const copy = COPY[outcome];

  return (
    <main className="mx-auto flex min-h-screen max-w-xl items-center justify-center p-4">
      <Card className={['w-full border-l-4 text-center', copy.tone].join(' ')}>
        <h1 className="text-2xl font-semibold">{copy.title}</h1>
        <p className="mt-3 text-sm">{copy.body}</p>
        <p className="mt-6 text-xs text-slate-500">You can close this page.</p>
      </Card>
    </main>
  );
};

export default Confirmation;
